export const getUniqueCategoriesFromShops = shops => {
    let uniqCategories = {};
    shops.forEach(shop => {
        shop.categories.forEach(category => {
            uniqCategories[category] = true;
        });
    });
    return Object.keys(uniqCategories);
};



// WEBPACK FOOTER //
// ./src/modules/getUniqueCategoriesFromShops.js